import React, {useState} from 'react'
import RoutingAddModal from "./RoutingAddModal";

function RoutingAdd(props) {
    const [isOpen, setIsOpen] = useState(false)

    const _toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <span onClick={_toggleModal} className="material-icons cursor-pointer text-primary">add</span>
            {isOpen && <RoutingAddModal isOpen={isOpen} toggleModal={_toggleModal} {...props}/>}
        </>
    )
}

export default RoutingAdd
